import state from './state'
import mutations from './mutations'
import actions from './actions'

const user = {
  actions,
  state,
  mutations
}

export default user



// WEBPACK FOOTER //
// ./src/store/user/index.js